import React from 'react';
import companyLogo from "../assets/zakhealth-logo.svg"; // Ensure this path is correct

const Home: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-center px-4">

            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800 tracking-tight mb-6">
                Coming Soon...
            </h1>

            <div className="my-8">
                <img
                    src={companyLogo}
                    alt="ZAK Health Logo"
                    className="h-20"
                />
            </div>

            <a
                href="mailto:info@zakhealth.com"
                className="
                    px-8 py-3 
                    bg-red-700 text-white 
                    font-semibold 
                    rounded-lg 
                    shadow-md 
                    hover:bg-red-800 
                    focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 
                    transition-all duration-300 ease-in-out
                    transform hover:scale-105
                "
            >
                Contact Us
            </a>
        </div>
    );
};

export default Home;